function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

export async function api(path, options = {}) {
  const response = await fetch(`/api${path}`, {
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken(), ...(options.headers || {}) },
    ...options
  })
  if (response.status === 401) {
    window.location.href = "/session/new"
    return
  }
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}))
    throw new Error(payload.error || payload.message || `HTTP ${response.status}`)
  }
  return response.status === 204 ? null : response.json()
}

export function post(path, body) {
  return api(path, { method: "POST", body: JSON.stringify(body) })
}

export async function postStream(path, body, onEvent) {
  const response = await fetch(`/api${path}`, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken() },
    body: JSON.stringify(body)
  })
  if (response.status === 401) {
    window.location.href = "/session/new"
    return
  }
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}))
    throw new Error(payload.error || payload.message || `HTTP ${response.status}`)
  }
  if (!response.body) throw new Error("Браузер не поддерживает потоковые ответы")

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  const eventStream = response.headers.get("content-type")?.includes("text/event-stream")
  let buffer = ""
  while (true) {
    const { value, done } = await reader.read()
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done })
    if (eventStream) {
      const blocks = buffer.split("\n\n")
      buffer = blocks.pop() || ""
      for (const block of blocks) {
        const data = block.split("\n").filter(line => line.startsWith("data:")).map(line => line.slice(5).trimStart()).join("\n")
        if (data) await onEvent(JSON.parse(data))
      }
    } else {
      const lines = buffer.split("\n")
      buffer = lines.pop() || ""
      for (const line of lines) {
        if (line.trim()) await onEvent(JSON.parse(line))
      }
    }
    if (done) break
  }
  if (!eventStream && buffer.trim()) await onEvent(JSON.parse(buffer))
}

export function patch(path, body) {
  return api(path, { method: "PATCH", body: JSON.stringify(body) })
}

export function remove(path) {
  return api(path, { method: "DELETE" })
}
